<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      left
      max-width="400"
      content-class="notification-menu"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          class="notification-btn"
        >
          <span v-if="unreadCount > 0" class="notification-count">{{ unreadCount }}</span>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
      </template>

      <v-card max-width="400">
        <v-card-title class="pa-3">
          <span class="text-h6">Notificaciones</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            small
            @click="markAllAsRead"
            :disabled="unreadCount === 0"
          >
            <v-icon small>mdi-check-all</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <div class="notifications-container">
          <v-list v-if="notifications.length > 0" class="pa-0">
            <template v-for="(notification, index) in notifications">
              <v-card
                :key="notification.id"
                flat
                :class="{ 'blue lighten-5': !notification.read }"
                class="ma-2"
                @click="markAsRead(notification)"
              >
                <v-card-text class="pa-3">
                  <div class="d-flex align-start">
                    <v-avatar
                      :color="notification.color"
                      size="40"
                      class="mr-3"
                    >
                      <v-icon dark>{{ notification.icon }}</v-icon>
                    </v-avatar>
                    <div class="flex-grow-1">
                      <div class="text-subtitle-2 font-weight-bold">
                        {{ notification.title }}
                      </div>
                      <div class="text-body-2 mt-1">
                        {{ notification.message }}
                      </div>
                      <div class="text-caption grey--text mt-1">
                        {{ notification.time }}
                      </div>
                    </div>
                    <v-btn
                      icon
                      x-small
                      @click.stop="removeNotification(notification.id)"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
              <v-divider
                v-if="index < notifications.length - 1"
                :key="`divider-${notification.id}`"
              ></v-divider>
            </template>
          </v-list>

          <div v-else class="text-center pa-5 grey--text">
            <v-icon size="64" color="grey lighten-1">mdi-bell-off</v-icon>
            <div class="mt-2">No hay notificaciones</div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-card-actions class="pa-2">
          <v-btn
            text
            small
            color="primary"
            block
            @click="viewAllNotifications"
          >
            Ver todas las notificaciones
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'NotificationMenu',
  
  data() {
    return {
      menu: false,
      notifications: [
        {
          id: 1,
          title: 'Nueva tarea asignada',
          message: 'Se te ha asignado una nueva tarea: "Revisar documentos del proyecto Alpha"',
          time: 'Hace 5 minutos',
          icon: 'mdi-clipboard-check',
          color: 'blue',
          read: false
        },
        {
          id: 2,
          title: 'Mensaje recibido',
          message: 'Juan Pérez te ha enviado un mensaje sobre la reunión de mañana',
          time: 'Hace 15 minutos',
          icon: 'mdi-message',
          color: 'green',
          read: false
        },
        {
          id: 3,
          title: 'Documento aprobado',
          message: 'El documento "Propuesta Q4 2024" ha sido aprobado por el director',
          time: 'Hace 1 hora',
          icon: 'mdi-file-check',
          color: 'success',
          read: false
        },
        {
          id: 4,
          title: 'Recordatorio',
          message: 'Reunión de equipo en 30 minutos en la sala de conferencias',
          time: 'Hace 2 horas',
          icon: 'mdi-alarm',
          color: 'orange',
          read: true
        },
        {
          id: 5,
          title: 'Actualización del sistema',
          message: 'El sistema se actualizará esta noche a las 23:00. Guarda tu trabajo',
          time: 'Hace 3 horas',
          icon: 'mdi-update',
          color: 'purple',
          read: true
        },
        {
          id: 6,
          title: 'Nuevo usuario registrado',
          message: 'María González se ha registrado en el sistema',
          time: 'Hace 5 horas',
          icon: 'mdi-account-plus',
          color: 'teal',
          read: true
        },
        {
          id: 7,
          title: 'Alerta de seguridad',
          message: 'Se detectó un intento de acceso desde una ubicación desconocida',
          time: 'Hace 1 día',
          icon: 'mdi-shield-alert',
          color: 'red',
          read: true
        }
      ]
    }
  },

  computed: {
    unreadCount() {
      return this.notifications.filter(n => !n.read).length
    }
  },

  methods: {
    markAsRead(notification) {
      notification.read = true
      // Aquí puedes agregar lógica para persistir el estado
      console.log('Notificación marcada como leída:', notification.id)
    },

    markAllAsRead() {
      this.notifications.forEach(notification => {
        notification.read = true
      })
      // Aquí puedes agregar lógica para persistir el estado
      console.log('Todas las notificaciones marcadas como leídas')
    },

    removeNotification(id) {
      const index = this.notifications.findIndex(n => n.id === id)
      if (index !== -1) {
        this.notifications.splice(index, 1)
      }
      // Aquí puedes agregar lógica para persistir el cambio
      console.log('Notificación eliminada:', id)
    },

    viewAllNotifications() {
      this.menu = false
      // Aquí puedes navegar a una página completa de notificaciones
      console.log('Ver todas las notificaciones')
      this.$emit('view-all')
    }
  }
}
</script>

<style scoped>
/* Contenedor de notificaciones con scroll */
.notifications-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Animación suave para el scroll */
.notifications-container::-webkit-scrollbar {
  width: 6px;
}

.notifications-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notifications-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.notifications-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Estilo para el contador de notificaciones */
.notification-btn {
  position: relative;
}

.notification-count {
  position: absolute;
  top: 2px;
  left: -2px;
  background-color: #f44336;
  color: white;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 11px;
  font-weight: bold;
  line-height: 1;
  min-width: 18px;
  text-align: center;
  z-index: 1;
}
</style>

<style>
/* Estilos globales para el menú de notificaciones (sin scoped para que afecte al v-menu) */
.notification-menu.v-menu__content {
  margin-top: -16px !important;
}
</style>